<template>
  <div class="compressed-content">
    <div class="page-question">
      <h3>
        Have you had a positive DNA test for familial hypercholesterolemia?
        <span class="information-popover" v-b-popover.hover.auto="hypercholesterolemiaInformation">i</span>
      </h3>
      
    </div>

    <v-form-group class="card-selector page-buttons" :validator="$v.hadPositiveTest">
      <b-form-radio v-model="survey.bloodBiochemistry.hypercholesterolemia.hadPositiveTest" name="test"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.hypercholesterolemia.hadPositiveTest" name="test"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { hypercholesterolemiaInformation } from '@/constants';

  export default {
    mixins: [formMixin],

    data() {
      return {
        hypercholesterolemiaInformation,
      }
    },

    validations: {
      hadPositiveTest: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadPositiveTest() { return this.survey.bloodBiochemistry.hypercholesterolemia.hadPositiveTest }
    }
  };
</script>